import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {BaseComponent} from '../../../shared/components/base/base.component';
import {Router} from '@angular/router';
import {Iproject} from '../../../models/project.model';
import {ProjectService} from '../../../services/project/project.service';
import {IBatchForecastMeasurement} from '../../../models/batch-forecast-measurement.model';
import {IBatch} from '../../../models/batch.model';
import {environment} from '../../../../environments/environment';
import {FileInputComponent, ImportFile, RuntimeConfiguration} from '@colorcare/ngx-cloud-storage';
import {IUserSummary, IUserSummaryActor, ServiceType, UserManagementClient} from '@colorcare/user-management-client';
import {take, takeUntil} from 'rxjs/operators';
import {VectorService} from '../../../services/vector/vector.service';
import {ChartDataService} from "../../../services/chart-data/chart-data.service";
import {IMwgData} from "../../../models/chart-mwg.model";
import {MixedMeasurementResponse} from "../../../models/vector-api/mixed-measurement-response.model";
import {IFdgData} from "../../../models/chart-fdg.model";
import {IFogData} from "../../../models/chart-fog.model";
import {ILpgData} from "../../../models/chart-lpg.model";
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {ColorDataService} from "../../../services/color-data/color-data.service";
import {VectorHistory} from "../../../models/vector-api/vector-history.model";
import {LocalStorageService} from "../../../services/local-storage/local-storage.service";
import {Recipe} from "../../../models/vector-api/recipe.model";
import {RecipeEntry} from "../../../models/vector-api/recipe-entry.model";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ChartFilters} from "../../../models/chart-filters.model";
import {IKpiLine} from "../../../models/kpi.model";
import {MatButtonToggle, MatButtonToggleChange, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {VectorHistoryService} from "../../../services/vector/vector-history.service";
import {VectorTheory} from "../../../models/vector-api/vector-theory.model";
import {forkJoin, Observable} from "rxjs";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {OffsetDto} from "../../../models/vector-api/offset-dto.model";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";
import {OffsetDialogComponent} from "../offset-dialog/offset-dialog.component";
import {OffsetHistoryService} from "../../../services/vector/offset-history.service";
import {DisplayBlobService} from "../../../shared/services/display-blob/display-blob.service";
import {CommonModule, formatDate} from "@angular/common";
import {ToleranceViewerDto} from "../../../models/viewmodels/tolerance-viewer-dto.model";
import {ToleranceDialogComponent} from "../../../components/tolerance-dialog/tolerance-dialog.component";
import {DampingDialogComponent} from "../damping-dialog/damping-dialog.component";
import {MatCard} from "@angular/material/card";
import {LoaderComponent} from "../../../shared/components/loader/loader.component";
import {MatIcon} from "@angular/material/icon";
import {ProjectHeaderComponent} from "../../../components/project/project-header.component";
import {ModalComponent} from "../../../shared/components/modal/modal.component";
import {FormsModule} from "@angular/forms";
import {MultiLineTooltipDirective} from "../../../shared/directives/multi-line-tooltip/multi-line-tooltip.directive";
import {MWGchartListComponent} from "../../../components/chart-mwg/mwg-chart-list.component";
import {ChartTableComponent} from "../../../components/chart-table/chart-table.component";
import {MatInput} from "@angular/material/input";
import { MatTooltip } from '@angular/material/tooltip';
import {MatFormField, MatLabel, MatOption, MatSelect} from "@angular/material/select";
import {MatIconButton} from "@angular/material/button";
import {MatSuffix} from "@angular/material/form-field";
import {MatGridList, MatGridTile, MatGridTileText} from "@angular/material/grid-list";
import {VectorPasteAmountFilterPipe} from "../../../pipes/vector-paste-amount-filter/vector-paste-amount-filter.pipe";
import {MatSlideToggle} from "@angular/material/slide-toggle";


@Component({
  selector: 'colimo-vector-tinting-page',
  templateUrl: './vector-tinting-page.component.html',
  styleUrls: ['./vector-tinting-page.component.scss'],
  imports: [
    CommonModule,
    MatCard,
    LoaderComponent,
    MatIcon,
    ProjectHeaderComponent,
    TranslateModule,
    ModalComponent,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatTooltip,
    MatFormField,
    MatSelect,
    MatLabel,
    MatSelect,
    FormsModule,
    MatCheckbox,
    MatTooltip,
    MatTooltip,
    MatTooltip,
    MatFormField,
    MatLabel,
    MatLabel,
    MatSelect,
    MatSelect,
    MatOption,
    MatIconButton,
    MatSuffix,
    MatFormField,
    MatLabel,
    MatSelect,
    MatSelect,
    MatSelect,
    MultiLineTooltipDirective,
    MWGchartListComponent,
    ChartTableComponent,
    MatTooltip,
    MatInput,
    MatTooltip,
    MatTooltip,
    MatTooltip,
    MatTooltip,
    MatTableModule,
    MatGridList,
    MatGridTileText,
    MatGridTile,
    VectorPasteAmountFilterPipe,
    MatSlideToggle,
    FileInputComponent
  ],
  providers: [ProjectService, LocalStorageService]
  })
export class VectorTintingPageComponent extends BaseComponent implements OnInit {

  public project: Iproject;
  public batch: IBatch;
  public kpiLine: IKpiLine;
  public mwgDataList: IMwgData[] = [];

  public labOn: boolean;
  public tolerancesOn: boolean;
  public selectedAngles: boolean[] = [true, true, true, true, true, true];
  /*public mwgTableDataAngles: any[] = [{"-15": true}, {"15": true}, {"25": true}, {"45": true}, {"75": true}, {"110": true}];
  public mwgTableDataAnglesSelectedAngles: boolean[] = [true, true, true, true, true, true];*/
  public chartFilters: ChartFilters;
  public refGraphColorIndicator: string;
  public mwgTableColorIndicator: string;

  public selectedForecastMeasurement: IBatchForecastMeasurement;
  public isForecastMeasurementLoading = false;
  public selectedTintingTargetMeasurement: IBatchForecastMeasurement;
  public selectedTintingTarget: string;
  public labTintingMode: string;
  public labTintingOffset: string;
  public selectedTintingTargetBatch: any;
  public selectedOffsetBatch: any;
  public selectedOffsetMeasurement: IBatchForecastMeasurement;
  public offsetDto: OffsetDto;
  public useOffset: boolean;

  // #442604 CARB for batch tinting
  public carbDto: OffsetDto;
  public useCarb: boolean;

  public cloudStorageConfig: RuntimeConfiguration;
  public cloudStorageInitializing: boolean = false;

  public displayedColumns: string[] = ['paste', 'amount', 'fixed', 'active'];
  public displayedColumnsHistory: string[] = ['color', 'created', 'cpi', 'ref', 'tolerance', 'mdE*', 'deleteHistory'];
  public recipeEntries: RecipeEntry[] = [];
  public hidePastesWithZeroAmount: boolean = false;
  public history: VectorHistory;
  public theoryDataSource;
  public tableMwgData: IMwgData;
  public refTableMwgData: IMwgData;
  public mainCardLoading: boolean = false;
  public pasteColumns: number = 1;
  public pasteColumnsHeightFactor: number = 20;
  private numberOfRecipeEntriesMaxSingleColumn = 10;

  private vectorFile: File;
  // default values for lower and upper bounds for recipe entries
  private LOWER_BOUND_DEFAULT: number = 0.0;
  private UPPER_BOUND_DEFAULT: number = 3.0;

  private currentOptions: { vectorFileName: string;
    calculatedWithOffset: boolean; offsetIdentifier: string;
    calculatedWithCarb: boolean; carbIdentifier: string;
    dampingFactor: number; dampingTheoryColor: string, dampingTheoryIndex: number;
    averageTheoryColors: string[], averageTheoryIndexes: number[] } = {} as any;

  private toleranceDialogRef?: MatDialogRef<ToleranceDialogComponent>;

  constructor(private router: Router,
              private vectorService: VectorService,
              private vectorHistoryService: VectorHistoryService,
              private chartDataService: ChartDataService,
              private colorDataService: ColorDataService,
              private projectService: ProjectService,
              private translate: TranslateService,
              private snackBar: MatSnackBar,
              private offsetHistoryService: OffsetHistoryService,
              private displayBlobService: DisplayBlobService,
              public matDialog: MatDialog,
              private cd: ChangeDetectorRef) {
    super();
    this.project = this.router.getCurrentNavigation().extras.state.project;
    this.batch = this.router.getCurrentNavigation().extras.state.batch;
    this.kpiLine = this.project.kpiLine;
    if (this.kpiLine) {
      // exclude corresponding measurements here
      this.chartFilters = {
        batchId: this.batch.batchId,
        lineId: this.kpiLine.lineNumber,
        /*
        // #436932 Fix problems with product_type BODY_BUMPER ==> do not set explicit filter here
        bumper: this.batch.productType === 'BUMPER',
        body: this.batch.productType === 'BODY' --this leads to bodyComp=- and bumperComp=- ==> not getting any data for BODY_BUMPER*/
      };
    } else {
      this.chartFilters = { batchId: this.batch.batchId };
    }
  }

  public ngOnInit(): void {
    this.initCloudStorageConfig();
    // default filters
    this.labOn = true;
    this.chartFilters.labSystem = 'LAB';
    this.selectedTintingTarget = VectorHistoryService.TINTING_TARGET_REF;
    this.labTintingMode = VectorHistoryService.LAB_TINTING_MODE_MASTER;
    this.labTintingOffset = VectorHistoryService.LAB_TINTING_OFFSET_BATCH;
    this.refGraphColorIndicator = this.colorDataService.getSimpleMultiBatchColors()[0];
    this.initEmptyState();
    this.loadHistory();
    if (this.batch && this.batch.forecastAvailable) {
      // #433181 Update retain sample measurements in lab use case
      this.loadRetainMeasurements();
    }
  }

  private loadMwgRefFromHistory(): boolean {
    const mwgRefHistory = this.vectorHistoryService.getMwgRef(this.getHistoryIdentifier(), this.chartFilters, this.selectedTintingTarget);
    if (mwgRefHistory) {
      this.mwgDataList.push(mwgRefHistory);
      this.refTableMwgData = mwgRefHistory;
      this.updateChartData(this.mwgDataList);
      this.tolerancesOn = mwgRefHistory.tolerances;
      this.mainCardLoading = false;
      return true;
    }
    return false;
  }

  private updateAllMwgDatas(): void {
    // we should also refresh the current offset here
    this.evaluateOffset();

    // this methods gets called when tolerances or color system changed
    // check what mwg data (ref and theories) is already present for the current filters and load all missing data from server
    this.mwgDataList = [];
    this.mainCardLoading = true;
    let mwgRefIncluded: boolean = false;

    const observables: Observable<IMwgData>[] = [];

    // load mwg ref data from history - if not present add call to server for mwg ref according to current mode
    if (!this.loadMwgRefFromHistory()) {
      if (this.project.kpiLine) {
        observables.push(this.chartDataService.getMwgDataOemLine(this.chartFilters));
      } else if (this.selectedForecastMeasurement && ((this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH && this.selectedTintingTargetBatch) ||
        (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS && this.selectedTintingTargetMeasurement))) {
        if (this.selectedForecastMeasurement && this.batch && (this.selectedTintingTargetBatch || this.selectedTintingTargetMeasurement)) {
          observables.push(this.chartDataService.getMwgDataForQCForReference(this.chartFilters, this.selectedForecastMeasurement.id,
            ((this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH && this.selectedTintingTargetBatch) ? this.selectedTintingTargetBatch.id : undefined),
            ((this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS && this.selectedTintingTargetMeasurement) ? this.selectedTintingTargetMeasurement.id : undefined)));
        }
      } else if (this.selectedForecastMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_REF) {
        if (this.selectedForecastMeasurement && this.batch) {
          observables.push(this.chartDataService.getMwgDataForQC(this.chartFilters, this.selectedForecastMeasurement.id));
        }
      }
      // will the response contain new reference mwg data
      mwgRefIncluded = (observables.length > 0);
    }

    // check for current Theories if mwg data for current filters is present - if not add call to server for theories according to current mode
    let currentHistory: VectorHistory = this.vectorHistoryService.getVectorHistory(this.getHistoryIdentifier());
    // this array holds the information for each theory if it was updated or not and gets queried for all theory responses
    const theoryUpdated: boolean[] = [];
    if (currentHistory && currentHistory.vectorTheories && currentHistory.vectorTheories.length > 0) {
      currentHistory.vectorTheories.forEach((theory) => {
        const mwgTheoryForHistory = this.vectorHistoryService.getMwgTheoryForFilters(theory, this.chartFilters, this.selectedTintingTarget);
        if (!mwgTheoryForHistory && theory.mixResponse && theory.mixResponse.Theory) {
          observables.push(this.chartDataService.getMwgDataForTheory(this.chartFilters, theory.mixResponse.Theory,
            (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH && this.selectedTintingTargetBatch) ? this.selectedTintingTargetBatch.id : undefined,
            (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS && this.selectedTintingTargetMeasurement) ? this.selectedTintingTargetMeasurement.id : undefined));
          theoryUpdated.push(true);
        } else {
          theoryUpdated.push(false);
        }
      });
    }

    if (observables.length > 0) {
      // load missing mwg data from server
      forkJoin(observables).pipe(takeUntil(this.stop$)).subscribe({
        next: (mwgDatas: IMwgData[]) => {
          if (mwgRefIncluded) {
            // updated to set initial correct value after the response for the chartFilters which is undefined initially (because tolerances are initially evaluated by the backend)
            if (this.chartFilters.tolerance === undefined) {
              this.chartFilters.tolerance = mwgDatas[0].tolerances;
            }
            // if ref was reloaded add ref as first mwgData
            if (this.selectedForecastMeasurement) {
              mwgDatas[0].table.name = this.selectedForecastMeasurement.info;
            }
            const mwgRef = this.vectorHistoryService.addMwgRef(this.getHistoryIdentifier(), this.chartFilters, mwgDatas[0], this.project, this.batch, this.selectedForecastMeasurement, this.kpiLine);
            this.mwgDataList.push(mwgRef);
            this.refTableMwgData = mwgRef;
          }
          // index if the ref is included or not needs to be shifted
          let indexOffset = mwgRefIncluded ? 1 : 0;
          let selectedTheoryIndex = -1;
          // history might have been updated with new mwgRef Data so reload it here
          currentHistory = this.vectorHistoryService.getVectorHistory(this.getHistoryIdentifier());
          if (currentHistory && currentHistory.vectorTheories && currentHistory.vectorTheories.length > 0) {
            currentHistory.vectorTheories.forEach((theory, index) => {
              //const mwgIndex = (index + indexOffset);
              if (theoryUpdated[index] && mwgDatas[indexOffset]) {
                theory = this.vectorHistoryService.updateTheoryMwg(theory, this.chartFilters, mwgDatas[indexOffset], this.batch, this.selectedTintingTarget);
                indexOffset++;
              }
              // check for selected
              if (theory.selected) {
                selectedTheoryIndex = index;
              }
            });
            // add updated theories to mwg chart data
            const mwgTheories: IMwgData[] = this.vectorHistoryService.getMwgTheoriesForHistory(currentHistory, this.chartFilters, this.selectedTintingTarget);
            if (mwgTheories && mwgTheories.length > 0) {
              this.mwgDataList.push(...mwgTheories);
            }
          }

          // update theory table data
          if (selectedTheoryIndex >= 0) {
            const theoryTableMwgData = this.vectorHistoryService.getMwgTheoryForFilters(currentHistory.vectorTheories[selectedTheoryIndex], this.chartFilters, this.selectedTintingTarget);
            if (theoryTableMwgData) {
              this.tableMwgData = theoryTableMwgData;
            }
          }

          // display updated data
          this.updateChartData(this.mwgDataList);
          this.vectorHistoryService.saveToStorage(this.getHistoryIdentifier(), currentHistory);
          this.history = currentHistory;
          this.theoryDataSource.data = this.history.vectorTheories;
          this.mainCardLoading = false;
        }, error: (error) => {
          // handle error
          this.showError(error);
          this.mainCardLoading = false;
        }
      });
    } else {
      // all data present in history just display it - only theories need to be added here to the graph data because ref is already present through history check on top of this function
      if (currentHistory && currentHistory.vectorTheories && currentHistory.vectorTheories.length > 0) {
        currentHistory.vectorTheories.forEach((theory) => {
          const mwgTheoryForHistory = this.vectorHistoryService.getMwgTheoryForFilters(theory, this.chartFilters, this.selectedTintingTarget);
          if (mwgTheoryForHistory) {
            this.mwgDataList.push(mwgTheoryForHistory);
          }
          // display selected theory table data
          const selectedTheoryIndex = this.getSelectedTheoryIndex();
          if (selectedTheoryIndex >= 0) {
            const theoryTableMwgData = this.vectorHistoryService.getMwgTheoryForFilters(currentHistory.vectorTheories[selectedTheoryIndex], this.chartFilters, this.selectedTintingTarget);
            if (theoryTableMwgData) {
              this.tableMwgData = theoryTableMwgData;
            }
          }
        });
      }

      // display data from history with updated mwgRef and theories according to the current selected Filters
      this.updateChartData(this.mwgDataList);
      this.mainCardLoading = false;
      if (currentHistory) {
        this.vectorHistoryService.saveToStorage(this.getHistoryIdentifier(), currentHistory);
        this.history = currentHistory;
        this.theoryDataSource.data = this.history.vectorTheories;
      }
    }
  }

  public onSelectedForecastMeasurementChanged(selectedMeasurement: IBatchForecastMeasurement) {
    this.selectedForecastMeasurement = selectedMeasurement;
    if (this.selectedForecastMeasurement) {
      this.loadHistory();
    }
  }


  /**
   * Calculates and applies average amounts for recipe entries across multiple theories.
   *
   * The method:
   * 1. Aggregates original amounts by entry name across all provided theories
   * 2. Calculates the average per entry (rounded to 2 decimals)
   * 3. Updates the current recipe entries with the computed averages
   *
   * Updated entries are marked as:
   * - userTouched = true
   * - IsFixed = true
   * - Bound_Lower / Bound_Upper = average value
   *
   * @param theories List of vector theories used for averaging
   */
  private setAverageAmounts(theories: VectorTheory[]): void {

    const sumMap: Record<string, { sum: number; count: number }> = {};

    // 1. Flatten + aggregate
    for (const theory of theories) {
      for (const entry of theory.recipeEntries) {
        if (entry.originalAmount == null) {
          continue; // skip undefined/null
        }

        if (!sumMap[entry.Name]) {
          sumMap[entry.Name] = { sum: 0, count: 0 };
        }

        sumMap[entry.Name].sum += entry.originalAmount;
        sumMap[entry.Name].count++;
      }
    }

    // 2. Calculate averages
    const averages: Record<string, number> = {};
    for (const name in sumMap) {
      const { sum, count } = sumMap[name];
      averages[name] = this.vectorService.round(sum / count, 2);
    }

    // 3. set amounts to averages
    if (this.recipeEntries && this.recipeEntries.length > 0) {
      this.recipeEntries.forEach((entry) => {
        if (averages[entry.Name] != null) {
          entry.Amount = averages[entry.Name];
          entry.userTouched = true;
          entry.IsFixed = true;
          entry.Bound_Lower = entry.Amount;
          entry.Bound_Upper = entry.Amount;
        }
      });
    }
  }


  /**
   * Evaluates whether an average calculation across selected theories should be performed.
   *
   * If at least two theories are ctrl-selected:
   * - Collects their colors for visualization
   * - Triggers average amount calculation
   *
   * Otherwise:
   * - Resets recipe entries to their original values
   *
   * Also clears previously calculated average color indicators before processing.
   */
  private evaluateTheoryAverage(): void {
    this.currentOptions.averageTheoryColors = []; // reset current options for averages
    // calc average amounts if at least 2 theories are ctrl selected
    const avgTheories = this.history.vectorTheories.filter(t => t.ctrlSelected);
    if (avgTheories.length >= 2) {
      this.currentOptions.averageTheoryColors = []; // reset current options for averages
      for (const theory of avgTheories) {
        this.currentOptions.averageTheoryColors.push(theory.color);
      }
      this.setAverageAmounts(avgTheories);
    } else {
      // reset of current paste amounts to original if not at least 2 ctrlSelected
      this.resetRecipeEntries();
    }
  }

  public historyClicked(row, event: MouseEvent): void {
    // control click is for theory amounts average calculation selection
    if (event.ctrlKey) {
      row.ctrlSelected = !row.ctrlSelected;
      this.evaluateTheoryAverage();
    } else {
      // only reset ctrl selected if this row is already selected
      if (row.selected) {
        // row is already selected
        if (row.ctrlSelected) {
          row.ctrlSelected = false;
          this.evaluateTheoryAverage();
        }
        return;
      }
      // reset recipe entries when another history is selected -- this should be optional but current ux works best like this
      this.resetCurrentOptionsAndRecipeEntries();
      this.history.vectorTheories.forEach((t) => {
        t.selected = false;
        t.ctrlSelected = false;
      });
      row.selected = true;
      this.recipeEntries = row.recipeEntries;
      this.evaluateRecipeColumns();
      this.tableMwgData = this.vectorHistoryService.getMwgTheoryForFilters(row, this.chartFilters, this.selectedTintingTarget);
      this.mwgTableColorIndicator = row.color;
      this.vectorHistoryService.saveToStorage(this.getHistoryIdentifier(), this.history);
      //this.vectorFile = row.vectorFile;
    }
  }

  private getSelectedTheoryIndex(): number {
    let index = -1;
    if (!this.history || !this.history.vectorTheories || this.history.vectorTheories.length < 1) {
      return index;
    }
    this.history.vectorTheories.forEach((t) => {
      if (t.selected) {
        index = this.history.vectorTheories.indexOf(t);
      }
    });
    return index;
  }

  public uploadVectorFile(): void {
    if (this.vectorFile && this.selectedForecastMeasurement && this.batch) {
      this.mainCardLoading = true;
      // check for user defined paste values
      const recipe: Recipe = this.vectorService.getCurrentRecipe(this.recipeEntries);

      this.vectorService.uploadVectorFile(this.vectorFile, this.selectedForecastMeasurement.id, this.batch.batchId,
        ((this.selectedTintingTargetBatch && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH) ? this.selectedTintingTargetBatch.id : undefined),
        ((this.selectedTintingTargetMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS) ? this.selectedTintingTargetMeasurement.id : undefined),
        this.chartFilters, recipe,
        ((this.useOffset && this.offsetDto) ? this.offsetDto : undefined),
        ((this.useCarb && this.carbDto) ? this.carbDto : undefined)).subscribe({
        next: (response: MixedMeasurementResponse) => {
          this.handleMixedMeasurementsResponse(response);
          this.mainCardLoading = false;
        }, error: (error) => {
          // error handling
          this.showError(error);
          this.mainCardLoading = false;
        }})
    }
  }

  public uploadVectorFileOemLine(): void {
    if (this.vectorFile && this.project.kpiLine.lineNumber && this.batch.batchId) {
      this.mainCardLoading = true;
      // check for user defined paste values
      const recipe: Recipe = this.vectorService.getCurrentRecipe(this.recipeEntries);

      this.vectorService.uploadVectorFileOemLine(this.vectorFile, this.project.kpiLine.lineNumber, this.batch.batchId, this.chartFilters, recipe).subscribe({
        next: (response: MixedMeasurementResponse) => {
          this.handleMixedMeasurementsResponse(response);
          this.mainCardLoading = false;
        }, error: (error) => {
          // error handling
          this.showError(error);
          this.mainCardLoading = false;
        }})
    }
  }

  private handleMixedMeasurementsResponse(response: MixedMeasurementResponse): void {
    if (!response) {
      this.showMsg('An error occurred -> No response');
      this.mainCardLoading = false;
      return;
    }

    if (response.Status !== 'OK') {
      this.showMsg('An error occurred -> ' + (response.Status ? response.Status : 'No response'));
      this.mainCardLoading = false;
      return;
    }

    this.recipeEntries = this.vectorService.setAmountForRecipeEntries(response);
    this.evaluateRecipeColumns();

    response.AvgView.startDate = response.Created.toString();
    const colorForHistory = this.vectorHistoryService.getColorForHistory(this.history.vectorTheories.length + 1, this.history);
    response.AvgView = this.vectorService.setCustomLabelForMwg(response.AvgView, 'theory-' + response.Created, colorForHistory);
    const mDE = this.vectorService.round(this.vectorService.calculateMdE(response.AvgView, this.batch), 2);
    if (mDE >= 0) {
      response.AvgView.table.name += ' - mdE* ' + mDE;
    }

    this.mwgDataList.push(response.AvgView);
    this.tableMwgData = response.AvgView;
    this.mwgTableColorIndicator = colorForHistory;
    this.updateChartData(this.mwgDataList);

    this.addTheoryToHistory(response, colorForHistory, mDE);
  }

  private addTheoryToHistory(response: MixedMeasurementResponse, colorForHistory: string, mdE: number): void {
    let currentHistory = this.vectorHistoryService.getVectorHistory(this.getHistoryIdentifier());
    if (currentHistory && currentHistory.vectorTheories && currentHistory.vectorTheories.length > 0) {
      currentHistory.vectorTheories.forEach((t) => {
        t.selected = false;
      });
    }
    // #555000 - improvements for tinting ui - add vectorFileName and offset/carb usage for theory tooltip with additional information
    this.currentOptions.vectorFileName = this.vectorFile.name;
    if (this.useOffset && this.offsetDto) {
      this.currentOptions.calculatedWithOffset = true;
      this.currentOptions.offsetIdentifier = (this.selectedOffsetMeasurement ? ( 'Measurement ' + this.selectedOffsetMeasurement.info + ' - ') : '') + 'Batch ' + this.selectedOffsetBatch.batchNumber;
    }
    if (this.useCarb && this.carbDto) {
      this.currentOptions.calculatedWithCarb = true;
      this.currentOptions.carbIdentifier = 'Batch ' + this.selectedTintingTargetBatch.batchNumber;
    }

    currentHistory = this.vectorHistoryService.addTheoryToHistory(currentHistory, this.chartFilters, response, this.recipeEntries, colorForHistory, mdE, this.selectedTintingTarget, this.currentOptions);
    this.history = currentHistory;
    this.theoryDataSource.data = this.history.vectorTheories;

    this.resetCurrentOptions();
  }

  public clearAllHistory(): void {
    this.vectorHistoryService.deleteAllVectorHistory();
    this.loadHistory();
  }

  public deleteHistory(row): void {
    this.history = this.vectorHistoryService.deleteSingleVectorHistory(this.history, row);
    this.theoryDataSource.data = this.history.vectorTheories;
    this.loadHistory();
  }

  private getHistoryIdentifier(): string {
    if (this.selectedForecastMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_REF) {
      return VectorHistoryService.STORAGE_PREFIX + 'P_' + this.project.id + '-B_' + this.batch.batchId + '-MQC_' + this.selectedForecastMeasurement.id + '-T_' +VectorHistoryService.TINTING_TARGET_REF;
    } else if (this.selectedForecastMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH && this.selectedTintingTargetBatch) {
      return VectorHistoryService.STORAGE_PREFIX + 'P_' + this.project.id + '-B_' + this.batch.batchId + '-MQC_' + this.selectedForecastMeasurement.id + '-T_B_' + this.selectedTintingTargetBatch.id;
    } else if (this.selectedForecastMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS && this.selectedTintingTargetMeasurement) {
      return VectorHistoryService.STORAGE_PREFIX + 'P_' + this.project.id + '-B_' + this.batch.batchId + '-MQC_' + this.selectedForecastMeasurement.id + '-T_M_' + this.selectedTintingTargetMeasurement.id;
    } else if (this.kpiLine) {
      return VectorHistoryService.STORAGE_PREFIX + 'P_' + this.project.id + '-B_' + this.batch.batchId + '-L_' + this.kpiLine.lineNumber + '-T_' + VectorHistoryService.TINTING_TARGET_REF;
    }

    return null;
  }

  private loadHistory(): void {
    this.evaluateCarb(); // #442604 CARB for batch tinting
    // check for local history in storage
    const localHistory: VectorHistory = this.vectorHistoryService.getVectorHistory(this.getHistoryIdentifier());
    // there is a case possible that there is no mwg for the localHistory because the localHistory was made with different chart filters
    // ==> load the mwg ref for the current filters from server
    const mwgRefHistory = this.vectorHistoryService.getMwgRef(this.getHistoryIdentifier(), this.chartFilters, this.selectedTintingTarget);
    if (!localHistory || !mwgRefHistory) {
      // no history so reset data and load the current ref data if possible
      this.initEmptyState();
      this.updateAllMwgDatas();
      return;
    }

    // display history from storage
    // ref data
    this.mwgDataList = [];
    this.mwgDataList.push(mwgRefHistory);
    this.refTableMwgData = mwgRefHistory;
    this.tolerancesOn = mwgRefHistory.tolerances;
    this.chartFilters.tolerance = this.tolerancesOn;

    // theory data if present
    if (localHistory.vectorTheories && localHistory.vectorTheories.length > 0) {
      const firstVectorTheory: VectorTheory = localHistory.vectorTheories[0];
      this.recipeEntries = firstVectorTheory.recipeEntries;
      this.evaluateRecipeColumns();
      this.tableMwgData = this.vectorHistoryService.getMwgTheoryForFilters(firstVectorTheory, this.chartFilters, this.selectedTintingTarget);
      this.mwgTableColorIndicator = firstVectorTheory.color;

      // select first theory
      localHistory.vectorTheories.forEach((t) => {
        t.selected = false;
      });
      firstVectorTheory.selected = true;

      // get mwg theories for selected tinting target
      const mwgTheories: IMwgData[] = this.vectorHistoryService.getMwgTheoriesForHistory(localHistory, this.chartFilters, this.selectedTintingTarget);
      if (mwgTheories && mwgTheories.length > 0) {
        this.mwgDataList.push(...mwgTheories);
      }
    } else {
      this.tableMwgData = null;
      this.mwgTableColorIndicator = null;
      this.recipeEntries = null;
    }

    this.history = localHistory;
    this.theoryDataSource.data = this.history.vectorTheories;
    this.vectorHistoryService.saveToStorage(this.getHistoryIdentifier(), this.history);
    this.updateChartData(this.mwgDataList);
  }

  private resetRecipeEntries(): void {
    if (this.recipeEntries && this.recipeEntries.length > 0) {
      this.recipeEntries.forEach((entry) => {
        entry.Amount = entry.originalAmount;
        entry.userTouched = false;
        entry.IsActive = entry.originalActive;
        entry.IsFixed = entry.originalFixed;
        if (entry.IsFixed) {
          entry.Bound_Lower = entry.Amount;
          entry.Bound_Upper = entry.Amount;
        } else {
          entry.Bound_Lower = this.LOWER_BOUND_DEFAULT;
          entry.Bound_Upper = this.UPPER_BOUND_DEFAULT;
        }
      });
    }
  }

  public hidePastesWithZeroAmounts(hide: boolean): void {
    this.hidePastesWithZeroAmount = hide;
  }

  public chartDataChanged(chartData: IMwgData | IFdgData | IFogData | ILpgData): void {
    setTimeout(() => {
      this.tolerancesOn = chartData.tolerances;
    })
  }

  public getMixedMeasurements(): void {
    if (!this.vectorFile) {
      this.showMsg('No Vector File selected');
      return;
    }

    if (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH && !this.selectedTintingTargetBatch) {
      this.showMsg('No Ref Batch selected');
      return;
    }

    if (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS && !this.selectedTintingTargetMeasurement) {
      this.showMsg('No Retain Sample selected');
      return;
    }

    if (this.project.kpiLine) {
      this.uploadVectorFileOemLine();
    } else if (this.selectedForecastMeasurement) {
      this.uploadVectorFile();
    }
  }

  public colorCoordinatesChanged(event: MatButtonToggleChange): void {
    this.labOn = event.value;
    this.chartFilters.tolerance = this.tolerancesOn;
    this.chartFilters.labSystem = this.labOn ? 'LAB' : 'LCH';
    this.updateAllMwgDatas();
    this.evaluateCarb(); // #442604 CARB for batch tinting
  }

  public tolerancesChanged(event: MatButtonToggleChange): void {
    this.tolerancesOn = event.value;
    this.chartFilters.tolerance = this.tolerancesOn;
    this.chartFilters.labSystem = this.labOn ? 'LAB' : 'LCH';
    this.updateAllMwgDatas();
    this.evaluateCarb(); // #442604 CARB for batch tinting
  }

  public angleSelectionChanged(event: MatCheckboxChange, index: number): void {
    this.selectedAngles[index] = event.checked;
    this.updateSelectedAngles(this.selectedAngles)
  }

  public updateSelectedAngles(updatedAngles: boolean[]): void {
    this.selectedAngles = [...updatedAngles];
    this.cd.detectChanges();
  }

  public updateRetainMeasurementsByBatchId(): void {
    this.isForecastMeasurementLoading = true;
    this.projectService.updateRetainMeasurementsByBatchId({ batchId: this.batch.batchId }).subscribe({
      next: (numberOfNewMeasurements: number) => {
        if (numberOfNewMeasurements > 0) {
          this.reloadForecastMeasurements();
          // #433181 Update retain sample measurements
          this.loadRetainMeasurements();
        }
        let message = this.translate.instant('dashboard.updateForecastMeasurements');
        if (numberOfNewMeasurements >= 0) {
          message += ' - ' + numberOfNewMeasurements + ' ' + this.translate.instant('dashboard.updatedForecastMeasurements');
        } else {
          message += ' - ' + this.translate.instant('dashboard.errorUpdatingForecastMeasurements');
        }
        this.showMsg(message);
        this.isForecastMeasurementLoading = false;
      },
      error: (error) => {
        this.isForecastMeasurementLoading = false;
        this.showError(error);
      },
      complete: () => {
        this.isForecastMeasurementLoading = false;
      },
    });
  }

  public tintingTargetChanged(event: MatButtonToggleChange): void {
    this.selectedTintingTarget = event.value;
    this.loadHistory();
  }

  public labTintingModeChanged(event: MatButtonToggleChange): void {
    this.labTintingMode = event.value;
    if (this.labTintingMode === VectorHistoryService.LAB_TINTING_MODE_MASTER) {
      if (!(this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_REF)) {
        this.tintingTargetChanged({ value: VectorHistoryService.TINTING_TARGET_REF } as MatButtonToggleChange);
      }
    } else if (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_REF) {
      this.tintingTargetChanged({ value: VectorHistoryService.TINTING_TARGET_BATCH } as MatButtonToggleChange);
    }
  }

  public labTintingOffsetChanged(event: MatButtonToggleChange): void {
    this.labTintingOffset = event.value;
  }

  public selectedOffsetBatchChanged(event: any): void {
    if (!event || !event.value) {
      this.selectedOffsetBatch = null;
      this.offsetDto = null;
      this.useOffset = false;
    } else {
      this.selectedOffsetBatch = event.value;
      this.evaluateOffset();
    }
  }

  public selectedOffsetMeasurementChanged(event: any): void {
    if (!event || !event.value) {
      this.selectedOffsetMeasurement = null;
      if (this.selectedOffsetBatch) {
        this.evaluateOffset();
      }
    } else {
      this.selectedOffsetMeasurement = event.value;
      if (this.selectedOffsetBatch) {
        this.evaluateOffset();
      }
    }
  }

  public openOffsetDialog(): void {
    if (this.offsetDto) {
      this.matDialog.open(OffsetDialogComponent, {
        data: {
          offsetDialogTitle: 'Offset: ' + (this.selectedOffsetMeasurement ? this.selectedOffsetMeasurement.info + ' - ' : '') + this.selectedOffsetBatch.batchNumber,
          mwgData: this.offsetDto.AvgView,
        },
      });
    } else {
      this.showMsg('No Offset calculated -> Select offset batch with optional retain sample');
    }
  }

  public offsetUsageChanged(event: MatCheckboxChange): void {
    this.useOffset = event.checked;
  }

  public openCarbDialog(): void {
    if (this.carbDto) {
      this.matDialog.open(OffsetDialogComponent, {
        data: {
          offsetDialogTitle: 'CARB: ' + this.selectedTintingTargetBatch.batchNumber,
          mwgData: this.carbDto.AvgView,
        },
      });
    } else {
      this.showMsg('No CARB calculated -> Select target batch');
    }
  }

  public carbUsageChanged(event: MatCheckboxChange): void {
    this.useCarb = event.checked;
  }

  private evaluateOffset(): void {
    if (this.selectedOffsetBatch && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_REF) {
      const offsetFromHistory = this.offsetHistoryService.getFromHistory(this.selectedOffsetBatch, this.selectedOffsetMeasurement, this.chartFilters, null, this.selectedTintingTarget);
      if (offsetFromHistory && offsetFromHistory.AvgView) {
        this.offsetDto = offsetFromHistory;
        this.useOffset = true;
        return;
      }
      this.mainCardLoading = true;
      this.vectorService.getOffset(this.selectedOffsetBatch.id, (this.selectedOffsetMeasurement ? this.selectedOffsetMeasurement.id : undefined), this.chartFilters).subscribe({
        next: (response: OffsetDto) => {
          this.offsetDto = response;
          this.useOffset = true;
          this.offsetHistoryService.addToHistory(this.selectedOffsetBatch, this.selectedOffsetMeasurement, this.chartFilters, response, null, this.selectedTintingTarget);
          this.mainCardLoading = false;
        }, error: (error) => {
          // error handling
          this.showError(error);
          this.offsetDto = null;
          this.useOffset = false;
          this.mainCardLoading = false;
        }, complete: () => {
          this.mainCardLoading =false;
        }})
    } else {
      this.offsetDto = null;
      this.useOffset = false;
    }
  }

  private evaluateCarb(): void {
    if (this.selectedTintingTargetBatch && (this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH || this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS)) {
      const carbFromHistory = this.offsetHistoryService.getFromHistory(this.selectedTintingTargetBatch, null, this.chartFilters, null, this.selectedTintingTarget);
      if (carbFromHistory && carbFromHistory.AvgView) {
        this.carbDto = carbFromHistory;
        return;
      }

      this.mainCardLoading = true;
      this.vectorService.getCarb(this.selectedTintingTargetBatch.id, this.chartFilters).subscribe({
        next: (response: OffsetDto) => {
          this.carbDto = response;
          this.offsetHistoryService.addToHistory(this.selectedTintingTargetBatch, null, this.chartFilters, response, null, this.selectedTintingTarget);
          this.mainCardLoading = false;
        }, error: (error) => {
          // error handling
          this.showError(error);
          this.carbDto = null;
          this.useCarb = false;
          this.mainCardLoading = false;
        }, complete: () => {
          this.mainCardLoading =false;
        }})
    } else {
      this.carbDto = null;
      this.useCarb = false;
    }
  }

  public selectedTintingTargetBatchChanged(event: any): void {
    if (!event || !event.value) {
      this.selectedTintingTargetBatch = null;
      this.evaluateCarb(); // #442604 CARB for batch tinting
    } else {
      this.selectedTintingTargetBatch = event.value;
    }
    if (this.selectedTintingTargetBatch) {
      this.loadHistory();
    }
  }

  public selectedTintingTargetMeasurementChanged(event: any): void {
    if (!event || !event.value) {
      this.selectedTintingTargetMeasurement = null;
    } else {
      this.selectedTintingTargetMeasurement = event.value;
    }
    if (this.selectedTintingTargetMeasurement) {
      this.loadHistory();
    }
  }

  public pasteAmountChanged(paste: RecipeEntry, newAmount: number): void {
    const entry = this.recipeEntries.find((p) => p.Name === paste.Name);
    if (entry.originalAmount !== newAmount) {
      paste.userTouched = true;
    } else {
      paste.userTouched = false;
    }
  }

  public setAllPastesActivated(active: boolean): void {
    if (!this.recipeEntries || this.recipeEntries.length < 1) {
      return;
    }
    this.recipeEntries.forEach((entry) => {
      entry.IsActive = active;
    });
  }

  public setAllPastesFixed(fixed: boolean): void {
    if (!this.recipeEntries || this.recipeEntries.length < 1) {
      return;
    }
    this.recipeEntries.forEach((entry) => {
      entry.IsFixed = fixed;
    });
  }

  public forecastInit(selectedForecastMeasurementId: number): void {
    setTimeout(() => {
      this.selectedForecastMeasurement = this.batch.forecastMeasurements.find((item: IBatchForecastMeasurement) => {
        return item.id === selectedForecastMeasurementId;
      });
    });
  }

  public vectorFileChanged(importFiles: ImportFile[]): void {
    if (importFiles && importFiles.length > 0) {
      this.vectorFile = importFiles[0];
    } else {
      this.vectorFile = null;
    }
  }

  public vectorFileInputChanged(event: any): void {
    if (event.target.files && event.target.files.length > 0) {
      this.vectorFile = event.target.files[0];
    } else {
      this.vectorFile = null;
    }
  }

  public downloadCpbAndExportPdf(): void {
    this.downloadCpb();
  }

  public calculateCpiForecast(theory: VectorTheory): void {
    const theoryMeasurement = theory.mixResponse.Theory;
    if (!this.batch || !this.selectedOffsetBatch || !theoryMeasurement) {
      let msg = 'Missing: ';

      if (!this.batch) {
        msg += ' batch - ';
      }
      if (!this.selectedOffsetBatch) {
        msg += ' offset reference batch -';
      }
      if (!theoryMeasurement) {
        msg += ' selected theory ';
      }

      this.showMsg(msg + ' for cpi forecast calculation');
      return;
    }

    this.mainCardLoading = true;
    this.vectorService.getForecast(this.batch.batchId, this.selectedOffsetBatch.id, theoryMeasurement, this.selectedOffsetMeasurement ? this.selectedOffsetMeasurement.id : null).subscribe({
      next: (forecastBatch: IBatch) => {
        if (this.forecastPresent(forecastBatch)) {
          if (!theory.cpiForecasts) {
            theory.cpiForecasts = {};
          }
          theory.cpiForecasts[forecastBatch.cpiForecast.referenceBatch + (this.selectedOffsetMeasurement ? ('-' + this.selectedOffsetMeasurement.id) : '')] = forecastBatch.cpiForecast.value;
        } else {
          this.showMsg("Error calculating cpi forecast ==> " + this.evaluateForecastErrMsg(forecastBatch));
        }
        this.mainCardLoading = false;
      }, error: (error) => {
        // error handling
        this.showError(error);
        this.mainCardLoading = false;
      }, complete: () => {
        this.mainCardLoading = false;
      }
    })
  }

  private forecastPresent(forecastBatch: IBatch): boolean {
    return (forecastBatch && forecastBatch.cpiForecast && forecastBatch.cpiForecast.value && forecastBatch.cpiForecast.value > 0);
  }

  private evaluateForecastErrMsg(forecastBatch: IBatch): string {
    let err = 'Unknown';
    if (forecastBatch && forecastBatch.cpiForecast && forecastBatch.cpiForecast.value) {
      if (forecastBatch.cpiForecast.value === -2) {
        err = 'Batch has not enough measurements';
      }
    }
    return err;
  }

  private getSelectedTheory(): any {
    let selectedTheory = undefined;
    if (!this.history || !this.history.vectorTheories || this.history.vectorTheories.length < 1) {
      return selectedTheory;
    }
    this.history.vectorTheories.forEach(t => {
      if (t.selected) {
        selectedTheory = t.mixResponse.Theory;
      }
    });
    return selectedTheory;
  }

  private downloadCpb(): void {
    const selectedTheory = this.getSelectedTheory();
    if (!this.batch || !this.selectedForecastMeasurement || !selectedTheory) {
      let msg = 'Missing: ';

      if (!this.batch) {
        msg += ' batch - ';
      }
      if (!this.selectedForecastMeasurement) {
        msg += ' tinting start -';
      }
      if (!selectedTheory) {
        msg += ' selected theory ';
      }

      this.showMsg(msg + ' for cpb export');
      return;
    }

    this.mainCardLoading = true;
    this.vectorService.exportClipboard(this.batch.batchId, this.selectedForecastMeasurement.id, selectedTheory,
      ((this.selectedTintingTargetBatch && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH) ? this.selectedTintingTargetBatch.id : undefined),
      ((this.selectedTintingTargetMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS) ? this.selectedTintingTargetMeasurement.id : undefined))
      .subscribe({
        next: (clipboard: Blob) => {
          const fileName = this.getExportFileName();
          this.displayBlobService.displayBlob(clipboard, fileName + '.cpb');
          this.mainCardLoading = false;
          this.exportPageAsPdf(fileName);
        }, error: (error) => {
          // error handling
          this.showError(error);
          this.mainCardLoading = false;
        }, complete: () => {
          this.mainCardLoading = false;
        }
      });
  }

  private exportPageAsPdf(fileName: string): void {
    setTimeout(() => {
      document.title = fileName;
      window.print();
    }, 500);
  }

  private getExportFileName(): string {
    let fileName = formatDate(new Date(), 'yyyyMMddHHmmss', 'en');
    fileName += '_B_' + this.batch.batchNumber;
    fileName += '_P_' + this.batch.productName;
    fileName += '_S_' + this.selectedForecastMeasurement.info.replaceAll(' ', '').replaceAll(':', '');
    if (this.selectedTintingTargetBatch && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_BATCH) {
      fileName += '_TB_' + this.selectedTintingTargetBatch.batchNumber;
    } else if (this.selectedTintingTargetMeasurement && this.selectedTintingTarget === VectorHistoryService.TINTING_TARGET_RS) {
      fileName += '_TRS_' + this.selectedTintingTargetMeasurement.info.replaceAll(' ', '').replaceAll(':', '');
    } else {
      fileName += '_TMASTER';
    }

    return fileName;
  }

  private updateChartData(data: IMwgData[]): void {
    this.vectorService.updateMwgData(data);
  }

  private initEmptyState(): void {
    this.mwgDataList = [];
    this.updateChartData(this.mwgDataList);
    this.history = { vectorTheories: [] } as VectorHistory;
    this.theoryDataSource = new MatTableDataSource(this.history.vectorTheories);
    this.recipeEntries = [];
    this.refTableMwgData = null;
    this.tableMwgData = null;
    this.mwgTableColorIndicator = null;
  }

  private showMsg(msg: string, duration?: number): void {
    this.snackBar.open(msg, 'Close', { duration: duration ? duration : 3500 });
  }

  private showError(error: any, duration?: number): void {
    const dura = duration ? duration : 5000;
    if (error && error.error && error.error.apierror && error.error.apierror.message) {
      this.snackBar.open(error.error.apierror.message, 'Close', { duration: dura, politeness: 'assertive'});
    } else {
      this.snackBar.open('An error occurred', 'Close', { duration: dura, politeness: 'assertive'});
    }
  }

  private evaluateRecipeColumns(): void {
    if (this.recipeEntries && this.recipeEntries.length > this.numberOfRecipeEntriesMaxSingleColumn) {
      this.pasteColumns = 2;
    } else {
      this.pasteColumns = 1;
    }
  }

  private reloadForecastMeasurements(): void {
    this.isForecastMeasurementLoading = true;
    this.projectService.getForecastMeasurementsByBatchId({ batchId: this.batch.batchId }).subscribe({
      next: (forecastMeasurements: IBatchForecastMeasurement[]) => {
        if (forecastMeasurements) {
          /*// reset current selection after update
          this.selectedMeasurementChanged(null)*/
          this.batch.forecastMeasurements = forecastMeasurements;
        }
      },
      error: () => {
        this.isForecastMeasurementLoading = false;
      },
      complete: () => {
        this.isForecastMeasurementLoading = false;
      },
    });
  }

  private loadRetainMeasurements(): void {
    this.isForecastMeasurementLoading = true;
    this.projectService.getRetainMeasurementsByBatchId({ batchId: this.batch.batchId }).subscribe({
      next: (retainMeasurements: IBatchForecastMeasurement[]) => {
        if (retainMeasurements) {
          this.batch.retainMeasurements = retainMeasurements;
        }
      },
      error: () => {
        this.isForecastMeasurementLoading = false;
      },
      complete: () => {
        this.isForecastMeasurementLoading = false;
      },
    });
  }

  private initCloudStorageConfig(): void {

    const jwt = localStorage.getItem('JWT');
    if (!jwt) {
      return;
    }
    const mayBeEvolutionToken: string = jwt.substring(jwt.indexOf(' ') + 1);
    if (!mayBeEvolutionToken) {
      return;
    }
    const userManagementClient: UserManagementClient = new UserManagementClient({
      baseUrl: environment.colorCareEvoUserUrl,
      token: mayBeEvolutionToken,
    });

    this.cloudStorageInitializing = true;

    userManagementClient.getCurrentUserSummary().pipe(take(1)).subscribe({next: (userSummary: IUserSummary) => {
      // check if the user has an evolution actor
      if (userSummary && userSummary.actors && userSummary.actors.length > 0) {
        const udsActor: IUserSummaryActor = userSummary.actors.find(actor => actor.client.service.type === ServiceType.USER_DATA);
        if (udsActor) {
          this.cloudStorageConfig = {
            token: mayBeEvolutionToken,
            actorId: udsActor.id,
            clientId: udsActor.client.id
          };
        }
        this.cloudStorageInitializing = false;
      }
    }, error: () => {
      // do nothing in case of error
      this.cloudStorageConfig = null;
      this.cloudStorageInitializing = false;
    }, complete: () => {
      this.cloudStorageInitializing = false;
    }});
  }

  // #487495 - Tolerance viewer
  public showTolerances(): void {
    if (this.project && this.project.id) {
      this.projectService.getTolerancesByProject(this.project.id).pipe(take(1)).subscribe({
        next: (response: ToleranceViewerDto) => {
          this.openToleranceDialog(response);
        },
        error: (error) => {
          this.showError(error);
        }
      });
    }
  }

  private openToleranceDialog(toleranceData: ToleranceViewerDto): void {
    // If already open, just bring it to front / update data (optional)
    if (this.toleranceDialogRef) {
      // optional: update dialog data if you want “latest click wins”
      this.toleranceDialogRef.componentInstance.data.toleranceData = toleranceData;
      this.toleranceDialogRef.updatePosition(); // harmless nudge; optional
      return;
    }

    this.toleranceDialogRef = this.matDialog.open(ToleranceDialogComponent, {
      data: { toleranceData },
      disableClose: true,
      hasBackdrop: false
    });

    this.toleranceDialogRef.afterClosed().subscribe(() => {
      this.toleranceDialogRef = undefined;
    });
  }

  /**
    Shows dialog for the damping factor selection
   */
  public showDampingFactorDialog(): void {
    const dampingDialogRef = this.matDialog.open(DampingDialogComponent, { data: { selectedDampingFactor: this.currentOptions.dampingFactor } });
    dampingDialogRef.afterClosed().subscribe(result => {
      if (result >= 0) { // what should happen on zero
        const curTheory = this.history.vectorTheories[this.getSelectedTheoryIndex()];
        this.currentOptions.dampingFactor = result;
        this.currentOptions.dampingTheoryIndex = this.getSelectedTheoryIndex();
        this.currentOptions.dampingTheoryColor = curTheory.color;
        this.dampingFactorSelected(result);
      } else {
        // do nothing if nothing was selected
      }
    });
  }

  /**
    Sets all amounts of the current recipe entries to their original amounts reduced by the damping factor
   */
  private dampingFactorSelected(dampingFactor: number): void {
    if (this.recipeEntries && this.recipeEntries.length > 0) {
      this.recipeEntries.forEach((entry) => {
        if (entry.IsActive) {
          entry.Amount = this.vectorService.round((entry.originalAmount * (100 - dampingFactor) / 100), 2); // #557834 - Update damping factor for CoLiMo tinting
          entry.userTouched = true;
          entry.IsFixed = true;
          entry.Bound_Lower = entry.Amount;
          entry.Bound_Upper = entry.Amount;
        }
      });
    }
  }

  /**
    Resets recipe entries, all ctrl selected and all current additional options
   */
  public resetCurrentOptionsAndRecipeEntries(): void {
    this.resetRecipeEntries();
    const avgTheories = this.history.vectorTheories.filter(t => t.ctrlSelected);
    avgTheories.forEach((t) => {
      t.ctrlSelected = false;
    });
    this.resetCurrentOptions();
  }

  /**
    Resets the current options which are used for additional theory tooltip information introduced during #555000 tinting ui improvements
   */
  private resetCurrentOptions(): void {
    this.currentOptions = {} as any;
  }

  protected readonly VectorHistoryService = VectorHistoryService;
}
